










import { defineComponent, computed, ref, watch } from '@vue/composition-api';
import { useResumeV2 } from '../../../hooks/useResume';


export default defineComponent({
    name: 'k-image',
    props: {
        src: {
            type: String,
            default: '',
        },
        defaultSrc: {
            type: String,
            default: '',
        },
        errorType: {
            type: String,
            default: 'default',
        },
        importance: {
            type: String,
            default: 'auto',
        },
    },
    setup(props) {
        const errorSrc = ref('');

        const errorSrcMap = {
            default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAE+AQMAAACJDg+hAAAABlBMVEXl5eX////ixexJAAAAI0lEQVRo3u3BAQ0AAAwCIPuX/gs4EwC5KQAAAAAAAAAAANA9U2od4wAkgOcAAAAASUVORK5CYII=',
            transparent: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnwAAACAAQMAAACr7CZeAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAACFJREFUaN7twTEBAAAAwiD7pzbDfmAAAAAAAAAAAAAA0QEogAABQn3PeAAAAABJRU5ErkJggg==',
            mainDark: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAACiBAMAAAB8GsSVAAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAACHRSTlM9QQA2MiQbCkm323QAAABzSURBVGje7dq7DYNAEADR9Tc2sguwTgJS6AA6QFSAKIH+A3q4JXyTvw4mSjs3dX33En3Ud8Q/oe+xJfQrhoR+xiehbzRN0zRN0zRN0zRN0zRN0zRN0zRN0zRN0zRN0xfqKaEfsST0O3eBJQ+00o1NXb+1nMRlFi+6MBseAAAAAElFTkSuQmCC',
            mainLight: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA3SURBVHgB7dTBCQAgEAPB1diC/Rcqggq2ELhHFu5780sD5r2NJ43/fGGqYy5AgAABKgBvTYUvHSAIAzdBuIPGAAAAAElFTkSuQmCC',
            football: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABUCAMAAAB+1AOtAAAA8FBMVEX////7+/ttbW24uLipqan29vZwcHDz8/Pa2tq6urrV1dVzc3NeXl7w8PClpaXe3t5paWmrq6teXV2hoaF2dnbl5eXIyMicnJzh4eG0tLR5eXliYmKfn5/Ozs5cXFy/v799fX2urq5ZWVnw8PDt7e3R0dGHh4ddXV1ZWFjq6urLy8uYmJh9fX14eHiLi4vEw8Td3d2qqqqTk5OOjo6Uk5PNzc1eXl5ubm5/fn/ExMSRkZGgoKB5eXl0dHSkpKRTU1OHh4dkZGRvb2+ioqJST1Czs7N9fX11dXWUlJR6enpubm5gYGCKioqHh4dxcXGOjo4TuQM3AAAAUHRSTlMzra1FSq2tra2tra2eNq05rZ6amK2tra2tra2tT62Nra2snq2tra2omK2trXdoXEGtra2tVj6scGOspKKDa6WakoB3railoZyZk46HaqGagfoy1wgAAANHSURBVGje7dlXd9owFAdwXxnk2MTgtkBYMXuvMDJIyG4zO77/tylxMLIsVT0nkl9y/Hs0Dzd/WZKvFC0Wi8Vin4qdENO1aNiXjX3fwxfKo/ewt9QiUWkgX7YNlDxGG46b0aJw6yDfQRJoc+/xyViLQKVLAucgxCp5PzSO1de1XRJ4BmHJtPdD+VR94QkJXCsAI1fCOJXC+7rywNcksAkcVn5jYI5UF74sk8BJ+LeLitq6GbKUsAkCR2u1hU9RdivVMUCkrjSyfr7ns+otEEm+ZBTOrFEuMH+LIFSdqCu8vIIAsy+OfDNVNrP+UDtVywSh1VhZ4B9AMY9A6GmqKPBzaGyNYhJE9u7UFD6rQkh+D4jIdpHMA4QZ9b6xA6zc2laxWVrAyM8PdmZNYNwriHx8zlkxCxRQ5ER2FfQdZCnRnY7oKzk8OZOtm7gChtFBQTgNIW2Meseym2WfsyliRCmF1rUxR6gsGXlSSrKBsyhkznkTPV1qKbl4wBQuYhSCLWpL9d5EWWoXGXdRx2C6K8SYN9k/rLGU6TschEymn2ThFez0a8jjvEr0HeW3qdOkZ2wKcXTIHKz7z7qVD+8d39GbOhV4iBEHnllbg93vjitZ2KQLIx5c39tqBwrbUj1th15QVhZxLHJkqP3K3cTHJ1fPQWgFtBkvcD6wmraTq/wquZwgpMBZTsPgqJjvkfcTUhuIYzGfJpMNTO2ZrYWC89uyBgyjxgQGyoBsmVIdNaNKljL5LoZm/skkis/iIrSUmG4vi65lzxP2HYlDjyUJnGOP6V5gORlx68M/LrdcTd64DYz8ML1TNIBxkFDR3t4wbWSz2EoSnEPySM3tx4p5x23xse1cV3NIfW6GA4uPMO2fqm64Qoe2YkEc+EnZbdeaqtQ3QahKAktHvqACtyI/mJONMxC58L/AKu9wp78OfYOZASLGi630uslJ+TpN4UDPElFdsKWEQ11Ya2qNy+SoJBrrCz3CS9QicORN06xW66Mor43J6ZCwSngDNXTlhTMuiZxmB/sebZDDaUT/GkgVmO35vfXsTbUI3JL5NTe4nQG5gFBKD9xZH/LuCBx3qkXBHve++h6/UX57D3sVLRq2LjbVYrFYLPap/AVuIVEapnSHxwAAAABJRU5ErkJggg==',
            avatar: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAV1BMVEUAAADn5+fk5OTk5OTj4+Pk5OTl5eXf39/k5OTl5eXl5eXk5OTi4uLj4+Pm5ubk5OTk5OTi4uLl5eXk5OT////9/f3n5+f5+fnt7e3y8vL29vbq6urv7+9GZ+CAAAAAE3RSTlMAIO+/34CvEM9gn3CgQG+QMFBP9mL7OAAAAqdJREFUWMOtmQmOozAQRb0BAZKe9HzvcP9zTtKRJlJjV4HJO8DTt8uWi0KwyLGbtDF4oIzuu++7OMfw1StsUP0o240aVXST93ZVoJnkUSURslErexC0aTuF/XT7Yl5wCLMj7JfCQdTMOf+AoG0LBo0m9EBuZyMXWXUaELSVa7jgBJfyDmicQhePPE7yp3A+cZp5UySF06jfxTL4ABd2Q09fLQmaJQVnrQtpObABV1AkZ//jIij6nUGXl/Kt9SC47Qqa7IudYfWeoMkWiFRUPmi0JRxRr4kN6p0tW1FFDT/SEVWyrZC4y6rrQW0Nx5RKskEP1mqgV+/q0kyvvydWX8fRt0qhxmIJiPoLcacOKYFHFSm+G6XE+R9F9/mkHVGn1j3FJDSaqh8IqSYfp9B0TmGEQp2VqBMpBYF3xOoJCCkVdWGlx3c1gZMe34AARmqOW50HidpIeWsGg9kcfu5BdeuOTvUKFv9uUUICT7+zNVtiehD9zjZtxMf5KyQ+zp14TlpRxMNHwbaTMz7M+JAOYFjimnLOIYSc0xoXMEjmoyym4OwGuk3XQtTX71OwBCH66uofDApb1reR8BZXX2t6k7O7cLHW9Irb75SEktXK4vezD/YQeRN0G3Vx9iDOl4K+bxXT6vDWqfQNvVh7yioLH7ze2SZCeZZ0wZNsG4l4YkpDBG9bCcUhgpj5KnE98FwcyKV2aawM5zRVJ77+ujbs8q7ZeRmqYznvGp1GEgNEHxpK/8gpqVFnQ7USPep8Xa3oDi19fQ3kSGYFnw8tXc2CRZr9YV18z2MZup0PikuA6sRO5BXw0fFK9JuYjBYx1415AaBvvGmrfXgLeUOKANS0VfLIUePJknII7scWQl4jnugv4mhy3vJPLsbIc//uem1+3MboqRv52vwD7lCiHpaoriAAAAAASUVORK5CYII=',
            flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQAQMAAAA26i3WAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlM9QR2g9IAAAAAUSURBVAjXY/j//z9DAwMjORikFwCoQQ0Jlt2YVwAAAABJRU5ErkJggg==',
        } as Record<string, string>;

        const imgUrl = computed(() => {
            // 移除图片后面的参数
            const srcWithQuery = props.src?.replace(/\?.*$/, '');
            return errorSrc.value || srcWithQuery || errorSrcMap[props.errorType] || errorSrcMap.default;
        });

        // 兜底URL
        const errorImgUrl = computed(() => {
            return props.defaultSrc || errorSrcMap[props.errorType] || errorSrcMap.default;
        });

        useResumeV2(() => {
            if (errorSrc.value) {
                errorSrc.value = '';
            }
        });

        watch(() => props, () => {
            if (errorSrc.value) {
                errorSrc.value = '';
            }
        }, { deep: true });


        return {
            imgUrl,
            errorImgUrl,
        };
    },
});
